import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { AlertController } from '@ionic/angular';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppUpdateService {
  constructor(private readonly updates: SwUpdate, public alertController: AlertController) {
    if (this.updates.isEnabled) {
      this.updates.versionUpdates
          .pipe(
              filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
          )
          .subscribe(event => {
            this.presentAlert();
          });
    }
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: 'The app has been updated',
      backdropDismiss: false,
      message: 'Press OK to reload.',
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            this.updates.activateUpdate().then(() => {
              window.location.reload();
            });
          }
        }
      ]
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }

  doAppUpdate() {
    this.updates.activateUpdate().then(() => document.location.reload());
  }
}